module.exports = __webpack_public_path__ + "static/media/2025-10-13 - VW - US_FAQS (Revised per Oregon).9c59e3fd.pdf";